
import React, { useState, Fragment, useRef, useEffect } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { setOrderIsReady } from "services"
import { Button, ConfirmationModal } from "components"

const OrderDetailReadyButton = props => {
  const { order, setOrders } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handleCompleteOrder = async () => {
    setSending(true)

    try {
      await setOrderIsReady(order._id)

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ?
            {
              ...o,
              isOrderReady: true,
              orderReadyAt: new Date()
            }
            : o
        )
      )

      setShowConfirmationModal(false)
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_ویرایش_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <Button
        fullWidth
        color="info"
        onClick={() => setShowConfirmationModal(true)}
      >
        {t("آماده_تحویل")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_وضعیت_این_سفارش_به_آماده_برای_تحویل_تغییر_دهید")}
        show={showConfirmationModal}
        onConfirm={handleCompleteOrder}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default OrderDetailReadyButton